import axiosInstance from "./api";
import { API_BASE_URL, resolveDirectApiBaseUrl } from "./api";
import { tryParseFourayRawBuffer } from "./runAgentResponse";
import { normalizeOutputTableName } from "../services/automationOutputService";
const token = localStorage.getItem("token");

const AGENT_EXECUTE_ENDPOINT = "/api/v1/agent/execute";
const AGENT_EXECUTE_STREAM_ENDPOINT = "/api/v1/agent/execute_stream";
const AGENT_EXECUTE_AGENT_ENDPOINT = "/api/v1/agent/execute_agent";
const AGENT_EXECUTE_MANUAL_ENDPOINT = "/api/v1/agent/execute_manual_agent";
const FORM_FIELDS = {
  AGENT_ID: "agent_id",
  AGENT_NAME: "agent_name",
  QUERY: "query",
  STREAMING: "streaming",
  FILES: "files[]",
  SESSION_ID: "session_id",
  LOCATION: "location",
  USER_TIMEZONE: "user_timezone",
  VARIABLES: "variables",
  FILTERS: "filters",
  METADATA: "metadata",
  OUTPUT_TABLE_NAME: "output_table_name",
  AUTOMATION_ID: "automation_id",
  SOURCE: "source",
};
const SSE_PREFIXES = {
  EVENT: "event: ",
  DATA: "data: ",
};

export const fetchProducts = async () => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("Unauthorized: No token found");
  }
  try {
    const response = await axiosInstance.get("/products", {
      headers: {
        Authorization: token,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error.response || error.message);
    throw error;
  }
};

export const scrapReferenceUrl = async (url) => {
  try {
    const response = await axiosInstance.post(
      "/upload/website",
      { url },
      {
        headers: {
          Authorization: token,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error scraping URL:", error);
    throw error;
  }
};

export const uploadFilesToApi = async (formData) => {
  try {
    const response = await axiosInstance.post("/upload/file", formData, {
      headers: {
        // 'Content-Type': 'multipart/form-data',
        // 'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    return response;
  } catch (error) {
    console.error("Upload failed:", error);
    throw error;
  }
};

// Process a streaming response
export const processStreamResponse = async (
  response,
  onChunk,
  onComplete,
  onError
) => {
  console.warn(
    "Stream processing not supported - use processSSEResponse instead"
  );
  throw new Error("Stream processing not supported in this environment");
};

// Try to parse streaming data
export const tryParseStreamData = (data, isFinal = false) => {
  console.warn("Stream parsing not supported - use processSSEResponse instead");
  return null;
};

export const generateProductDescription = async (
  sku,
  keywords,
  section = "",
  furtherDetails = "",
  agentId,
  sessionId
) => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("Unauthorized: No token found");
  }
  const payload = {
    request_type: "product_description",
    additional_data: {
      sku: sku,
      keywords: keywords,
      section: section,
      further_details: furtherDetails,
      agent_id: agentId,
      session_id: sessionId,
    },
  };
  try {
    const response = await axiosInstance.post("/generate/product", payload, {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error(
      "Error generating product description:",
      error.response || error.message
    );
    throw error;
  }
};
export const getFileIcon = (fileType) => {
  if (fileType.includes("pdf")) {
    return "/pdf.svg";
  } else if (fileType.includes("image")) {
    return "/img.svg";
  } else if (fileType.includes("word")) {
    return "/doc.svg";
  } else if (fileType.includes("csv")) {
    return "/csv.svg";
  }
  return "/doc.svg";
};

export const convertFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};
export const generateEmailDescription = async (
  templateName,
  occasion,
  tone,
  furtherDetails,
  agentId,
  sessionId,
  previewImage
) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Unauthorized: No token found");

  const payload = {
    preview_image:
      previewImage,
    request_type: "email",
    additional_data: {
      agent_id: agentId,
      session_id: sessionId,
      tone: tone,
      occasion: occasion,
      template: templateName,
      further_details: furtherDetails,
    },
  };

  try {
    const response = await fetch(`https://stage-api.var80.com/generate/email`, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok || !response.body) {
      throw new Error("Network response error or no body");
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    let eventStream = "";

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      const chunk = decoder.decode(value, { stream: true });
      eventStream += chunk;
    }

    try {
      const parsedJson = tryParseSSE(eventStream);
      console.log("Parsed JSON:", parsedJson);

      // If it's an array of sections, return it directly
      if (Array.isArray(parsedJson)) {
        return parsedJson;
      }

      // Return a valid fallback array with one section
      return [{
        id: `section-${Date.now()}`,
        component_name: "Banner",
        title: "Welcome!",
        description: "This is a default section.",
        image: "https://via.placeholder.com/800x400/e0e0e0/999999?text=Banner+Image"
      }];

    } catch (err) {
      console.error("Parsing failed:", err);
      // Return a valid fallback array with one section
      return [{
        id: `section-${Date.now()}`,
        component_name: "Banner",
        title: "Welcome!",
        description: "This is a default section.",
        image: "https://via.placeholder.com/800x400/e0e0e0/999999?text=Banner+Image"
      }];
    }
  } catch (error) {
    console.error("Error generating email:", error.response || error.message);
    throw error;
  }
};

const tryParseSSE = (data) => {
  try {
    const lines = data.split("\n");
    let jsonChunks = [];

    for (const line of lines) {
      if (line.startsWith("data:")) {
        const cleaned = line.replace(/^data:\s?/, "");
        if (cleaned !== "") {
          jsonChunks.push(cleaned);
        }
      }
    }

    const combined = jsonChunks.join("");
    const firstBrace = combined.indexOf("{");
    const lastBrace = combined.lastIndexOf("}");

    if (firstBrace >= 0 && lastBrace > firstBrace) {
      const jsonStr = combined.substring(firstBrace, lastBrace + 1);

      try {
        const parsed = JSON.parse(jsonStr);

        if (parsed && parsed.response && Array.isArray(parsed.response)) {
          return parsed.response;
        }
      } catch (err) {
        console.error("❌ Final JSON parsing failed", err);
      }
    }
  } catch (parseErr) {
    console.warn("Error while parsing SSE data:", parseErr);
  }
};

// Process SSE text response
export const processSSEResponse = (text) => {
  try {
    if (!text) return null;

    console.log("Processing SSE text response");

    // Split by lines and process each line
    const lines = text.split("\n");
    let jsonChunks = [];

    for (const line of lines) {
      if (line.startsWith("data:")) {
        const cleaned = line.replace(/^data:\s*/, "").trim();
        if (cleaned && cleaned !== "") {
          jsonChunks.push(cleaned);
        }
      }
    }

    const combined = jsonChunks.join("");
    console.log("Combined JSON chunks:", combined);

    // Find the JSON object boundaries
    const firstBrace = combined.indexOf("{");
    const lastBrace = combined.lastIndexOf("}");

    if (firstBrace >= 0 && lastBrace > firstBrace) {
      const jsonStr = combined.substring(firstBrace, lastBrace + 1);

      try {
        const parsed = JSON.parse(jsonStr);
        console.log("✅ Successfully parsed JSON:", parsed);
        return parsed;
      } catch (err) {
        console.error("❌ JSON parse failed:", err);

        const jsonMatch = combined.match(/(\{.*\}|\[.*\])/s);
        if (jsonMatch) {
          try {
            const parsedBackup = JSON.parse(jsonMatch[0]);
            console.log(
              "✅ Successfully parsed JSON with backup method:",
              parsedBackup
            );
            return parsedBackup;
          } catch (e) {
            console.error("Secondary parsing failed:", e);
          }
        }
      }
    }

    const possibleJsons =
      combined.match(/(\{[^{}]*(((?<!\\\{)\{[^{}]*\})[^{}]*)*\})/g) || [];
    for (const jsonCandidate of possibleJsons) {
      try {
        const lastResortParsed = JSON.parse(jsonCandidate);
        console.log(
          "✅ Successfully parsed JSON with last resort method:",
          lastResortParsed
        );
        return lastResortParsed;
      } catch (e) {
        // Skip and try the next one
      }
    }

    return null;
  } catch (error) {
    console.error("Error processing SSE response:", error);
    return null;
  }
};

export const replacePlaceholders = (html, data) => {
  let updatedHtml = html;

  if (data.header) {
    Object.entries(data.header).forEach(([key, value]) => {
      const regex = new RegExp(`{{\\s*${key}\\s*}}`, "g");
      updatedHtml = updatedHtml.replace(regex, value);
    });
  }

  return updatedHtml;
};

export const executeAgentWithLongPolling = async (
  agentId,
  query = "",
  files = [],
  onChunk = null,
  onComplete = null,
  onError = null,
  sessionId = null,
  agentName = null
) => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("Unauthorized: No token found");
  }

  try {
    const formData = new FormData();
    formData.append(FORM_FIELDS.AGENT_ID, String(agentId));
    if (agentName) {
      formData.append(FORM_FIELDS.AGENT_NAME, String(agentName));
    }
    formData.append(FORM_FIELDS.QUERY, query || "Run");
    formData.append(FORM_FIELDS.STREAMING, "true");
    if (sessionId) {
      formData.append(FORM_FIELDS.SESSION_ID, String(sessionId));
    }

    files.forEach((file) => {
      formData.append(FORM_FIELDS.FILES, file);
    });

    const baseURL = axiosInstance.defaults.baseURL || API_BASE_URL;
    const response = await fetch(`${baseURL}${AGENT_EXECUTE_ENDPOINT}`, {
      method: "POST",
      headers: {
        Authorization: token.startsWith("Bearer ") ? token : `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    let buffer = "";
    let currentEvent = null;

    while (true) {
      const { done, value } = await reader.read();

      if (done) {
        if (onComplete) {
          onComplete();
        }
        break;
      }

      const chunk = decoder.decode(value, { stream: true });
      buffer += chunk;

      const lines = buffer.split("\n");
      buffer = lines.pop() || "";

      for (const line of lines) {
        const trimmedLine = line.trim();

        if (!trimmedLine) continue;

        try {
          if (trimmedLine.startsWith(SSE_PREFIXES.EVENT)) {
            currentEvent = trimmedLine.substring(SSE_PREFIXES.EVENT.length).trim();
          } else if (trimmedLine.startsWith(SSE_PREFIXES.DATA)) {
            const dataStr = trimmedLine.substring(SSE_PREFIXES.DATA.length).trim();
            let parsed;

            try {
              parsed = JSON.parse(dataStr);
            } catch (e) {
              console.warn("Failed to parse JSON:", dataStr, e);
              continue;
            }

            if (onChunk) {
              const eventType = currentEvent || (parsed.status ? parsed.status : "update");
              onChunk({
                status: eventType,
                payload: parsed,
                timestamp: new Date().toISOString(),
              });
            }
            currentEvent = null;
          } else if (trimmedLine.startsWith("{")) {
            let parsed;
            try {
              parsed = JSON.parse(trimmedLine);
            } catch (e) {
              console.warn("Failed to parse JSON:", trimmedLine, e);
              continue;
            }

            if (onChunk) {
              onChunk({
                status: parsed.status || "update",
                payload: parsed,
                timestamp: new Date().toISOString(),
              });
            }
          }
        } catch (e) {
          console.warn("Failed to process chunk:", trimmedLine, e);
        }
      }
    }
  } catch (error) {
    console.error("Error executing agent:", error);
    if (onError) {
      onError(error);
    } else {
      throw error;
    }
  }
};

const getAuthHeaders = (token, { acceptEventStream = false } = {}) => {
  const headers = {
    Authorization: token.startsWith("Bearer ") ? token : `Bearer ${token}`,
    "ngrok-skip-browser-warning": "true",
  };
  if (acceptEventStream) {
    headers.Accept = "text/event-stream";
  }
  return headers;
};

const parseVariablesObject = (variables) => {
  if (variables == null || variables === "") return {};
  if (typeof variables === "object" && !Array.isArray(variables)) return variables;
  if (typeof variables !== "string") return {};
  try {
    const parsed = JSON.parse(variables);
    return typeof parsed === "object" && parsed !== null && !Array.isArray(parsed)
      ? parsed
      : {};
  } catch {
    return {};
  }
};

const appendUploadFilesToFormData = (formData, files) => {
  if (!Array.isArray(files)) return;
  files.forEach((file) => {
    if (!file) return;
    const fileName =
      typeof file.name === "string" && file.name.trim() ? file.name.trim() : "upload";
    formData.append(FORM_FIELDS.FILES, file, fileName);
  });
};

const throwAgentHttpError = async (response, requestUrl) => {
  let message = `HTTP error! status: ${response.status}`;
  if (response.status === 413) {
    message =
      `Upload too large (413). Compare this request's Content-Length in Network tab with Postman. ` +
      `If the app URL is localhost (webpack proxy), set REACT_APP_API_BASE_URL to your API server URL. ` +
      `Request URL: ${requestUrl}`;
  }
  try {
    const bodyText = await response.text();
    if (bodyText) {
      const snippet =
        bodyText.length > 300 ? `${bodyText.slice(0, 300)}…` : bodyText;
      message = `${message} — ${snippet}`;
    }
  } catch {
    // ignore body read errors
  }
  throw new Error(message);
};

/** Known orchestrator SSE control events — do not treat arbitrary JSON with "type" as control. */
const SSE_CONTROL_EVENT_TYPES = new Set([
  "run_meta",
  "team_started",
  "team_completed",
  "member_started",
  "member_completed",
  "member_chunk",
  "tool_call_started",
  "tool_call_completed",
  "tool_call_delta",
]);

/** Get data line content: accept "data: " or "data:" (with/without space after colon) */
const getDataLineContent = (line) => {
  const match = line.match(/^\s*data:(.*)$/i);
  if (match) {
    const content = match[1];
    return content.startsWith(" ") ? content.substring(1) : content;
  }
  return null;
};

const ssePayloadSize = (value) => {
  try {
    return JSON.stringify(value ?? "").length;
  } catch {
    return 0;
  }
};

/**
 * Parse team/orchestrator SSE from execute_agent.
 * Assembles multi-line data: fields per SSE spec; keeps the largest parseable JSON payload.
 */
const processTeamAgentStreamResponse = async (
  response,
  onChunk = null,
  { onEvent = null, onComplete = null } = {}
) => {
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let buffer = "";
  let fullText = "";
  let pendingDataLines = [];
  let finalResponseBuffer = "";
  let bestParsedPayload = null;
  let bestPayloadSize = 0;
  let runId = null;
  let teamCompleted = false;
  let teamCompletedPayload = null;
  let onCompleteInvoked = false;

  const rememberPayload = (assembled) => {
    const trimmed = assembled.trim();
    if (!trimmed) return;

    finalResponseBuffer = trimmed;
    const parsed = tryParseFourayRawBuffer(trimmed);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return;

    const size = ssePayloadSize(parsed);
    if (size > bestPayloadSize) {
      bestPayloadSize = size;
      bestParsedPayload = parsed;
    }
  };

  const handleAssembledData = async (assembled) => {
    const trimmed = assembled.trim();
    if (!trimmed) return;

    let parsed = null;
    try {
      parsed = JSON.parse(trimmed);
    } catch {
      parsed = null;
    }

    if (
      parsed &&
      typeof parsed === "object" &&
      parsed.type &&
      SSE_CONTROL_EVENT_TYPES.has(parsed.type)
    ) {
      if (parsed.run_id) runId = parsed.run_id;
      if (onEvent) onEvent(parsed);

      if (parsed.type === "member_chunk") return;

      if (parsed.type === "team_completed") {
        teamCompleted = true;
        teamCompletedPayload = parsed;
      }
      return;
    }

    rememberPayload(assembled);
  };

  const flushSseEvent = async () => {
    if (pendingDataLines.length === 0) return;
    const assembled = pendingDataLines.join("\n");
    pendingDataLines = [];
    await handleAssembledData(assembled);
  };

  const processLine = async (line) => {
    const cleanLine = line.replace(/\r$/, "");
    const trimmedLine = cleanLine.trim();

    if (!trimmedLine) {
      await flushSseEvent();
      return;
    }

    if (trimmedLine.startsWith(":")) return;

    const dataContent = getDataLineContent(cleanLine);
    if (dataContent !== null) {
      pendingDataLines.push(dataContent);
      return;
    }

    // Pretty-printed JSON continuation lines without a "data:" prefix
    if (pendingDataLines.length > 0) {
      pendingDataLines.push(cleanLine);
    }
  };

  const invokeOnComplete = async () => {
    if (!onComplete || onCompleteInvoked) return;
    if (!finalResponseBuffer.trim() && !teamCompleted && !bestParsedPayload) return;

    onCompleteInvoked = true;
    const parsedFinal =
      bestParsedPayload ?? tryParseFourayRawBuffer(finalResponseBuffer) ?? finalResponseBuffer;
    await onComplete({
      finalResponse: parsedFinal,
      rawFinalBuffer: finalResponseBuffer,
      runId,
      payload: teamCompletedPayload,
    });
  };

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    const chunk = decoder.decode(value, { stream: true });
    fullText += chunk;
    if (onChunk) onChunk(chunk);

    buffer += chunk;
    const lines = buffer.split("\n");
    buffer = lines.pop() || "";

    for (const line of lines) {
      await processLine(line);
    }
  }

  if (buffer.trim()) {
    const cleanLine = buffer.replace(/\r$/, "");
    const dataContent = getDataLineContent(cleanLine);
    if (dataContent !== null) {
      pendingDataLines.push(dataContent);
    } else if (pendingDataLines.length > 0) {
      pendingDataLines.push(cleanLine);
    }
  }

  await flushSseEvent();
  await invokeOnComplete();

  return {
    finalResponse:
      bestParsedPayload ?? tryParseFourayRawBuffer(finalResponseBuffer) ?? finalResponseBuffer,
    rawFinalBuffer: finalResponseBuffer,
    runId,
    fullText,
  };
};

/**
 * Parse SSE from execute_manual_agent (event: start / analysing_data / processing / …).
 */
const processManualAgentStreamResponse = async (
  response,
  onChunk = null,
  { onParsedChunk = null, onComplete = null } = {}
) => {
  if (!response.ok) {
    await throwAgentHttpError(response, response.url);
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let buffer = "";
  let fullText = "";
  let currentEvent = null;
  let lastPayload = null;
  let onCompleteInvoked = false;

  const dispatchParsedChunk = (eventName, parsed) => {
    if (!onParsedChunk || !parsed || typeof parsed !== "object") return;

    lastPayload = parsed;
    onParsedChunk({
      status: (eventName || parsed.status || "update").toString(),
      payload: parsed,
      timestamp: new Date().toISOString(),
    });
  };

  const processLine = (line) => {
    const cleanLine = line.replace(/\r$/, "");
    const trimmedLine = cleanLine.trim();
    if (!trimmedLine) return;

    if (trimmedLine.startsWith(SSE_PREFIXES.EVENT)) {
      currentEvent = trimmedLine.substring(SSE_PREFIXES.EVENT.length).trim();
      return;
    }

    const dataContent = getDataLineContent(cleanLine);
    if (dataContent === null) return;

    let parsed = null;
    try {
      parsed = JSON.parse(dataContent.trim());
    } catch {
      return;
    }

    if (!parsed || typeof parsed !== "object") return;

    dispatchParsedChunk(currentEvent, parsed);
    currentEvent = null;
  };

  const invokeOnComplete = async () => {
    if (!onComplete || onCompleteInvoked) return;
    onCompleteInvoked = true;
    await onComplete({
      finalResponse: lastPayload,
      payload: lastPayload,
    });
  };

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    const chunk = decoder.decode(value, { stream: true });
    fullText += chunk;
    if (onChunk) onChunk(chunk);

    buffer += chunk;
    const lines = buffer.split("\n");
    buffer = lines.pop() || "";

    for (const line of lines) {
      processLine(line);
    }
  }

  if (buffer.trim()) {
    processLine(buffer.replace(/\r$/, ""));
  }

  await invokeOnComplete();

  return {
    finalResponse: lastPayload,
    fullText,
  };
};

const processAgentStreamResponse = async (response, onChunk = null, onParsedChunk = null) => {
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let buffer = "";
  let fullText = "";
  let currentEvent = null;
  /** Accumulate raw data line content (streamed fouray_response JSON fragments) until event: finished */
  let fourayChunkBuffer = "";

  const tryParseFourayBuffer = (str) => {
    if (!str || typeof str !== "string") return null;
    const s = str.trim();
    if (!s) return null;
    try {
      return JSON.parse(s);
    } catch (e) {
      const first = s.indexOf("{");
      const last = s.lastIndexOf("}");
      if (first >= 0 && last > first) {
        try {
          return JSON.parse(s.substring(first, last + 1));
        } catch (e2) {
          return null;
        }
      }
    }
    return null;
  };

  const processLine = (line) => {
    // Handle CRLF by removing \r if present; do NOT trim trailing spaces as they may be part of the content
    const cleanLine = line.replace(/\r$/, "");
    const trimmedLine = cleanLine.trim();

    if (!trimmedLine) return;

    try {
      if (trimmedLine.startsWith(SSE_PREFIXES.EVENT)) {
        const eventName = trimmedLine.substring(SSE_PREFIXES.EVENT.length).trim();
        if (eventName.toLowerCase() === "started") {
          fourayChunkBuffer = "";
        }
        currentEvent = eventName;
      } else {
        const dataContent = getDataLineContent(cleanLine);
        if (dataContent !== null) {
          const rawContent = dataContent;
          let parsed;
          try {
            parsed = JSON.parse(rawContent.trim());
          } catch (e) {
            parsed = null;
          }
          // Only treat OBJETCS as structural payloads. Primitives (numbers, strings) are content.
          if (parsed != null && typeof parsed === "object") {
            const invoicePayload = parsed?.invoice_processing ?? parsed?.invoice ?? parsed;
            const isFinishedPayload =
              invoicePayload &&
              (String(invoicePayload.status).toLowerCase() === "completed" ||
                String(invoicePayload.run_status).toLowerCase() === "success");
            const eventType = (currentEvent || parsed?.status || "update").toString();
            const isFinishedEvent = eventType.toLowerCase() === "finished";

            if (isFinishedEvent || isFinishedPayload) {
              const fourayResponse = tryParseFourayBuffer(fourayChunkBuffer);
              if (onParsedChunk) {
                onParsedChunk({
                  status: "finished",
                  payload: invoicePayload || parsed,
                  fouray_response: fourayResponse,
                  fouray_raw_buffer: fourayChunkBuffer && fourayChunkBuffer.length > 0 ? fourayChunkBuffer : undefined,
                  timestamp: new Date().toISOString(),
                });
              }
              fourayChunkBuffer = "";
              currentEvent = null;
            } else {
              if (onParsedChunk) {
                onParsedChunk({
                  status: eventType,
                  payload: parsed,
                  timestamp: new Date().toISOString(),
                });
              }
              currentEvent = null;
            }
          } else {
            fourayChunkBuffer += rawContent;
          }
        } else if (trimmedLine.startsWith("{")) {
          let parsed;
          try {
            parsed = JSON.parse(trimmedLine);
          } catch (e) {
            fourayChunkBuffer += trimmedLine;
            return;
          }
          if (onParsedChunk) {
            onParsedChunk({
              status: parsed?.status || "update",
              payload: parsed,
              timestamp: new Date().toISOString(),
            });
          }
        }
      }
    } catch (e) {
      // skip unparseable lines
    }
  };

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    const chunk = decoder.decode(value, { stream: true });
    fullText += chunk;
    if (onChunk) {
      onChunk(chunk);
    }

    buffer += chunk;
    const lines = buffer.split("\n");
    buffer = lines.pop() || "";

    for (const line of lines) {
      processLine(line);
    }
  }

  const parsed = processSSEResponse(fullText);
  return parsed != null ? parsed : fullText;
};

/**
 * Execute agent via streaming API (/api/v1/agent/execute_stream).
 * Streams the response, calls onChunk with raw text for accumulation,
 * and onParsedChunk with { status, payload } for each SSE event.
 * Returns the final parsed result (from processSSEResponse) for useStreamingJson.
 */
export const executeAgentStream = async (
  agentId,
  agentName,
  sessionId,
  query = "",
  files = [],
  onChunk = null,
  onParsedChunk = null
) => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("Unauthorized: No token found");
  }

  const formData = new FormData();
  formData.append(FORM_FIELDS.AGENT_ID, String(agentId));
  if (agentName) {
    formData.append(FORM_FIELDS.AGENT_NAME, String(agentName));
  }
  formData.append(FORM_FIELDS.STREAMING, "true");
  if (sessionId) {
    formData.append(FORM_FIELDS.SESSION_ID, String(sessionId));
  }
  formData.append(FORM_FIELDS.QUERY, query || "Extract the details from file");
  appendUploadFilesToFormData(formData, files);

  const baseURL = axiosInstance.defaults.baseURL || API_BASE_URL;
  const requestUrl = `${baseURL}${AGENT_EXECUTE_STREAM_ENDPOINT}`;
  const response = await fetch(requestUrl, {
    method: "POST",
    headers: getAuthHeaders(token),
    body: formData,
  });

  return processAgentStreamResponse(response, onChunk, onParsedChunk);
};

/**
 * Execute agent via /api/v1/agent/execute_agent (SSE stream, no file upload).
 */
export const executeAgent = async (
  agentId,
  agentName,
  sessionId,
  query = "",
  onChunk = null,
  callbacks = {},
  options = {}
) => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("Unauthorized: No token found");
  }

  const {
    location = "India",
    userTimezone = "Asia/Kolkata",
    variables = "{}",
    filters = "{}",
  } = options;

  const formData = new FormData();
  formData.append(FORM_FIELDS.AGENT_ID, String(agentId));
  if (agentName) {
    formData.append(FORM_FIELDS.AGENT_NAME, String(agentName));
  }
  formData.append(FORM_FIELDS.QUERY, query || "Extract invoice details and return JSON");
  formData.append(FORM_FIELDS.STREAMING, "true");
  if (sessionId) {
    formData.append(FORM_FIELDS.SESSION_ID, String(sessionId));
  }
  formData.append(FORM_FIELDS.LOCATION, location);
  formData.append(FORM_FIELDS.USER_TIMEZONE, userTimezone);
  formData.append(FORM_FIELDS.VARIABLES, variables);
  formData.append(FORM_FIELDS.FILTERS, filters);

  const baseURL = axiosInstance.defaults.baseURL || API_BASE_URL;
  const response = await fetch(`${baseURL}${AGENT_EXECUTE_AGENT_ENDPOINT}`, {
    method: "POST",
    headers: getAuthHeaders(token, { acceptEventStream: true }),
    body: formData,
  });

  return processTeamAgentStreamResponse(response, onChunk, callbacks);
};

/**
 * Execute automation manually via /api/v1/agent/execute_manual_agent (SSE).
 * Uses automation_agent_id as agent_id. Supports optional file uploads.
 */
export const executeManualAgent = async (
  agentId,
  sessionId,
  query = "",
  onChunk = null,
  callbacks = {},
  options = {}
) => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("Unauthorized: No token found");
  }

  if (!agentId) {
    throw new Error("agent_id is required for manual automation run");
  }

  const {
    agentName = null,
    files = [],
    location = "India",
    userTimezone = "Asia/Kolkata",
    variables = "{}",
    filters = "{}",
    metadata = "{}",
    outputTableName = "automation_outputs",
    automationId = null,
    source = "manual run",
  } = options;

  const variablesObject = parseVariablesObject(variables);
  const resolvedLocation =
    variablesObject.user_location ??
    variablesObject.location ??
    location;
  const resolvedTimezone =
    variablesObject.user_timezone ??
    variablesObject.userTimezone ??
    userTimezone;

  const formData = new FormData();
  formData.append(FORM_FIELDS.AGENT_ID, String(agentId));
  if (agentName) {
    formData.append(FORM_FIELDS.AGENT_NAME, String(agentName));
  }
  formData.append(FORM_FIELDS.QUERY, query || "fetch invoice details");
  formData.append(
    FORM_FIELDS.VARIABLES,
    typeof variables === "string" ? variables : JSON.stringify(variablesObject)
  );
  formData.append(FORM_FIELDS.FILTERS, filters);
  formData.append(FORM_FIELDS.METADATA, metadata);
  formData.append(FORM_FIELDS.SESSION_ID, String(sessionId));
  formData.append(FORM_FIELDS.OUTPUT_TABLE_NAME, normalizeOutputTableName(outputTableName));
  if (automationId != null && automationId !== "") {
    formData.append(FORM_FIELDS.AUTOMATION_ID, String(automationId));
  }
  formData.append(FORM_FIELDS.LOCATION, String(resolvedLocation));
  formData.append(FORM_FIELDS.USER_TIMEZONE, String(resolvedTimezone));
  formData.append(FORM_FIELDS.SOURCE, source);
  appendUploadFilesToFormData(formData, files);

  const requestUrl = `${resolveDirectApiBaseUrl()}${AGENT_EXECUTE_MANUAL_ENDPOINT}`;
  const response = await fetch(requestUrl, {
    method: "POST",
    headers: getAuthHeaders(token, { acceptEventStream: true }),
    body: formData,
  });

  return processManualAgentStreamResponse(response, onChunk, callbacks);
};